import { createReducer, on } from '@ngrx/store';
import * as PermissionActions from './permission.action';

export interface PermissionState {
  permissions: string[];
  myProfile: any;
  headerTitle: string;
}

// Helper function to safely load from sessionStorage
const loadFromSessionStorage = (key: string, defaultValue: any) => {
  try {
    const item = sessionStorage.getItem(key);
    return item ? JSON.parse(item) : defaultValue;
  } catch {
    return defaultValue;
  }
};

export const initialState: PermissionState = {
  permissions: loadFromSessionStorage('permissions', []),
  myProfile: loadFromSessionStorage('myProfile', null),
  headerTitle: sessionStorage.getItem('headerTitle') || ''
};

export const permissionReducer = createReducer(
  initialState,
  on(PermissionActions.setPermissions, (state, { permissions }) => {
    const safePermissions = Array.isArray(permissions) ? permissions : [];
    sessionStorage.setItem('permissions', JSON.stringify(safePermissions));
    return { ...state, permissions: safePermissions };
  }),
  on(PermissionActions.clearPermissions, state => {
    sessionStorage.removeItem('permissions');
    return { ...state, permissions: [] };
  }),
  on(PermissionActions.setMyProfile, (state, { myProfile }) => {
    sessionStorage.setItem('myProfile', JSON.stringify(myProfile));
    return { ...state, myProfile };
  }),
  on(PermissionActions.clearMyProfile, state => {
    sessionStorage.removeItem('myProfile');
    return { ...state, myProfile: null };
  }),
  on(PermissionActions.setHeaderTitle, (state, { headerTitle }) => {
    sessionStorage.setItem('headerTitle', headerTitle);
    return { ...state, headerTitle };
  }),
  on(PermissionActions.clearHeaderTitle, state => {
    sessionStorage.removeItem('headerTitle');
    return { ...state, headerTitle: '' };
  }),
  on(PermissionActions.addPermission, (state, { permission }) => {
    const updatedPermissions = [...state.permissions, permission];
    sessionStorage.setItem('permissions', JSON.stringify(updatedPermissions));
    return {
      ...state,
      permissions: updatedPermissions
    };
  }),
  on(PermissionActions.removePermission, (state, { permission }) => {
    const updatedPermissions = state.permissions.filter(p => p !== permission);
    sessionStorage.setItem('permissions', JSON.stringify(updatedPermissions));
    return {
      ...state,
      permissions: updatedPermissions
    };
  })
);
